module.exports = __webpack_public_path__ + "img/logo.8066b68f.png";